import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaFilePdf,
    FaArrowLeft
} from 'react-icons/fa';

const EngineerSocietyWorkDetail = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    // Dummy data matching the image
    const [works, setWorks] = useState([
        {
            id: 1,
            name: "कुसगाव ता.भोर येथील प्राथमिक शाळेच्या इमारतीची दुरुस्ती",
            lotteryDate: "२९ मार्च २०२३",
            price: "८४७०००",
            dept: "सा.बां. उत्तर विभाग",
            duration: "६ महिने",
            completionDate: "२०२३-१२-१३",
            status: "",
            remark: ""
        },
        {
            id: 2,
            name: "भोळवडे.ता.भोर येथे शाळा सुधार अंतर्गत झेडपी प्राथमिक शाळेच्या इमारतीची दुरुस्ती",
            lotteryDate: "२९ मार्च २०२३",
            price: "५९७०००",
            dept: "सा.बां. उत्तर विभाग",
            duration: "६ महिने",
            completionDate: "२०२३-१२-१३",
            status: "",
            remark: ""
        },
        {
            id: 3,
            name: "karandi.bk.tq.bhor येथील प्राथमिक शाळेच्या इमारतीची दुरुस्ती",
            lotteryDate: "२९ मार्च २०२३",
            price: "८४८०००",
            dept: "सा.बां. उत्तर विभाग",
            duration: "६ महिने",
            completionDate: "२०२३-१२-१३",
            status: "",
            remark: ""
        },
        {
            id: 4,
            name: "किशन ता.भोर येथील प्राथमिक शाळेच्या इमारतीची दुरुस्ती",
            lotteryDate: "२९ मार्च २०२३",
            price: "८४७०००",
            dept: "सा.बां. उत्तर विभाग",
            duration: "६ महिने",
            completionDate: "२०२३-१२-१३",
            status: "",
            remark: ""
        }
    ]);

    const handleUpdate = (workId) => {
        // Logic to update status and remark
        console.log(`Updating society work ${workId}`);
    };

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen font-marathi">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-8 px-2">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate('/engineer/society-work-list')}
                            className="p-2 bg-white rounded-full shadow-sm hover:bg-gray-50 transition text-gray-600 border border-gray-100"
                        >
                            <FaArrowLeft size={16} />
                        </button>
                        <h1 className="text-xl font-bold text-gray-800 tracking-tight">संस्थेचे नाव :- <span className="text-blue-600">धारेश्वर मजूर सहकारी संस्था</span></h1>
                    </div>
                    <div className="text-xs font-medium text-gray-400">
                        जिल्हा परिषद / <span className="text-gray-500 font-bold">सोसायटीच्या कामाची यादी पहा</span>
                    </div>
                </div>

                {/* Main Content Card */}
                <div className="bg-white rounded shadow-sm border border-gray-200 p-8 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-400 min-w-[1200px]">
                        <thead>
                            <tr className="bg-gray-50/50">
                                <th className="border border-gray-400 px-3 py-4 text-[13px] font-black text-gray-600 text-left w-12 font-marathi">अ.क्र.</th>
                                <th className="border border-gray-400 px-4 py-4 text-[13px] font-black text-gray-600 text-left font-marathi">कामाचे नांव</th>
                                <th className="border border-gray-400 px-4 py-4 text-[13px] font-black text-gray-600 text-left font-marathi">लॉटरी क्रमांक</th>
                                <th className="border border-gray-400 px-4 py-4 text-[13px] font-black text-gray-600 text-left font-marathi">कामाची किंमत</th>
                                <th className="border border-gray-400 px-4 py-4 text-[13px] font-black text-gray-600 text-left font-marathi">विभागाचे नाव</th>
                                <th className="border border-gray-400 px-4 py-4 text-[13px] font-black text-gray-600 text-left font-marathi">काम पूर्ण करणे</th>
                                <th className="border border-gray-400 px-4 py-4 text-[13px] font-black text-gray-600 text-left font-marathi">काम पूर्ण करण्याचा दिनांक</th>
                                <th className="border border-gray-400 px-4 py-4 text-[13px] font-black text-gray-600 text-left w-48 font-marathi">स्थिती निवडा</th>
                                <th className="border border-gray-400 px-4 py-4 text-[13px] font-black text-gray-600 text-left font-marathi">शेरा</th>
                                <th className="border border-gray-400 px-4 py-4 text-[13px] font-black text-gray-600 text-center w-28 font-marathi">कृती</th>
                            </tr>
                        </thead>
                        <tbody>
                            {works.map((work, index) => (
                                <tr key={work.id} className="text-[14px] text-gray-700 font-bold">
                                    <td className="border border-gray-400 px-3 py-6 font-marathi">{index + 1}</td>
                                    <td className="border border-gray-400 px-4 py-6">
                                        <div className="space-y-2">
                                            <div className="font-marathi leading-relaxed">{work.name}</div>
                                            <div className="inline-flex items-center justify-center p-1.5 bg-white border border-red-200 rounded cursor-pointer hover:bg-red-50 transition group">
                                                <FaFilePdf size={18} className="text-red-500 group-hover:scale-110 transition-transform" />
                                            </div>
                                        </div>
                                    </td>
                                    <td className="border border-gray-400 px-4 py-6 font-marathi">{work.lotteryDate}</td>
                                    <td className="border border-gray-400 px-4 py-6 font-marathi text-gray-600">८४७०००</td>
                                    <td className="border border-gray-400 px-4 py-6 font-marathi text-blue-600">{work.dept}</td>
                                    <td className="border border-gray-400 px-4 py-6 font-marathi">{work.duration}</td>
                                    <td className="border border-gray-400 px-4 py-6 font-marathi">{work.completionDate}</td>
                                    <td className="border border-gray-400 px-4 py-6">
                                        <select 
                                            className="w-full border border-gray-300 rounded px-3 py-2 outline-none focus:border-blue-500 bg-white text-xs text-gray-400 font-medium font-marathi"
                                            value={work.status}
                                            onChange={(e) => {
                                                const newWorks = [...works];
                                                newWorks[index].status = e.target.value;
                                                setWorks(newWorks);
                                            }}
                                        >
                                            <option value="">स्थिती</option>
                                            <option value="मंजूर">मंजूर</option>
                                            <option value="प्रलंबित">प्रलंबित</option>
                                        </select>
                                    </td>
                                    <td className="border border-gray-400 px-4 py-6">
                                        <input 
                                            type="text" 
                                            className="w-full border border-gray-300 rounded px-3 py-2 outline-none focus:border-blue-500 text-xs font-medium font-marathi placeholder:text-gray-300"
                                            placeholder="शेरा प्रविष्ट करा"
                                            value={work.remark}
                                            onChange={(e) => {
                                                const newWorks = [...works];
                                                newWorks[index].remark = e.target.value;
                                                setWorks(newWorks);
                                            }}
                                        />
                                    </td>
                                    <td className="border border-gray-400 px-4 py-6 flex items-center justify-center">
                                        <button 
                                            onClick={() => handleUpdate(work.id)}
                                            className="bg-[#4e73df] hover:bg-[#2e59d9] text-white px-4 py-2.5 rounded text-[11px] font-black uppercase tracking-tight transition active:scale-95 w-full font-marathi shadow-sm shadow-blue-100"
                                        >
                                            अपडेट करा
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <style>{`
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerSocietyWorkDetail;
